import { helpers } from 'vuelidate/lib/validators';

export const number = (value: unknown): boolean => {
    return (
        !helpers.req(value) || (typeof value === 'number' && isFinite(value))
    );
};
